import * as Yup from 'yup';
import { TFunction } from 'i18next';
import { getTranslationValidationHandling } from 'Hooks/query-hooks/helper';
import { PARAMETER_DISPLAY_NAME_REGEX } from 'Utils';

export const displayNameSchema = (t: TFunction, validationT: (s: string, options?: any) => string) => {
    const parameterDisplayName = t('Display Name');
    return Yup.string()
        .required(validationT('required', { field: parameterDisplayName }))
        .strict()
        .trim(validationT('noLeadingTrailingSpaces'))
        .matches(PARAMETER_DISPLAY_NAME_REGEX, t('invalidParameterDisplayName'))
        .min(1, validationT('minLength', { field: parameterDisplayName, charCount: 1 }))
        .max(32, validationT('maxLength', { field: parameterDisplayName, charCount: 32 }));
};

export const descriptionSchema = (t: TFunction, validationT: (s: string, options?: any) => string) => {
    const parameterDescription = t('Parameter Description');
    return Yup.string()
        .required(validationT('required', { field: parameterDescription }))
        .trim(validationT('noLeadingTrailingSpaces'))
        .strict()
        .min(1, validationT('minLength', { field: parameterDescription, charCount: 1 }))
        .max(150, validationT('maxLength', { field: parameterDescription, charCount: 150 }))
        .test({
            name: 'parameterDescription',
            exclusive: true,
            message: validationT('backslashOrSingleQuote'),
            // eslint-disable-next-line
            test: (value) => value?.match("[/\\\\']") === null
        });
};

export const addParameterValidationSchema = (t: TFunction) => {
    const validationT = getTranslationValidationHandling(t);
    return Yup.object({
        displayName: displayNameSchema(t, validationT),
        description: descriptionSchema(t, validationT),
        isScriptValidated: Yup.bool().oneOf([true])
    });
};
